'use client';

import { createBrowserClient } from '@supabase/ssr';

// Use the current browser origin so requests go through the Next.js proxy
// rewrites (next.config.ts) instead of hitting the private Supabase IP directly.
const supabaseUrl =
  typeof window !== 'undefined'
    ? window.location.origin
    : process.env.NEXT_PUBLIC_SUPABASE_URL!;

export const supabase = createBrowserClient(
  supabaseUrl,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
);
